package com.milta.core.localization.translations.ro

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Conectare",
    logout = "Deconectare",
    email = "Email",
    password = "Parolă",
    showPassword = "Afișați",
    hidePassword = "Ascundeți",
    roleSelectionTitle = "Creați un cont",
    roleSelectionSubtitle = "Alegeți tipul de cont care corespunde profilului dvs.",
    roleDriverTitle = "Sunt șofer - curier",
    roleDriverDescription = "Conduc un vehicul de transport sau livrare și doresc să optimizez turneele",
    roleDriverTag1 = "Optimizez turneele mele",
    roleDriverTag2 = "Oferte Milta pe ruta mea",
    roleEnterpriseTitle = "Sunt o companie",
    roleEnterpriseDescription = "Am un număr de TVA și gestionez o flotă de vehicule și o echipă de șoferi",
    roleEnterpriseTag1 = "Gestionare flotă",
    roleEnterpriseTag2 = "Urmărire echipe",
    continueButton = "Continuați",
    registerFormTitle = "Finalizați înregistrarea",
    registerFormSubtitle = "Confirmați numărul de telefon pentru a vă activa contul.",
    registerFormSubtitleEnterprise = "Introduceți organizația și un număr de telefon pentru a vă activa contul.",
    googleAccountConnected = "Cont Google conectat",
    appleAccountConnected = "Cont Apple conectat",
    firstName = "Prenume",
    lastName = "Nume",
    phoneNumber = "Număr de telefon",
    phoneNumberHelper = "Introduceți numărul de telefon dorit.",
    phoneNumberOtpInfo = "Un cod de verificare va fi trimis prin SMS pentru a confirma acest număr.",
    registerButton = "Primiți un cod de verificare",
    passwordHint = "Cel puțin 8 caractere",
    registerSuccess = "Cont creat cu succes",
    errorEmailConflict = "Această adresă de email este deja utilizată",
    errorPhoneConflict = "Acest număr de telefon este deja înregistrat",
    errorGeneric = "Conexiune eșuată. Verificați rețeaua și încercați din nou.",
    errorFirstNameRequired = "Vă rugăm să introduceți prenumele",
    errorFirstNameTooLong = "Prenumele nu poate depăși 100 de caractere",
    errorLastNameRequired = "Vă rugăm să introduceți numele",
    errorLastNameTooLong = "Numele nu poate depăși 100 de caractere",
    errorPhoneTooLong = "Numărul de telefon nu poate depăși 20 de caractere",
    errorOAuthAccountExists = "Acest cont este deja asociat cu un alt cont Milta. Încercați să vă conectați.",
    errorOAuthTokenInvalid = "Sesiunea dvs. a expirat. Vă rugăm să vă conectați din nou.",
    loginTitle = "Conectare",
    loginTabPassword = "Parolă",
    loginTabPhone = "Telefon",
    loginButton = "Conectare",
    forgotPassword = "Parolă uitată?",
    sendCodeButton = "Trimite cod",
    otpTitle = "Introduceți codul",
    otpSubtitle = "Am trimis un cod de 6 cifre la",
    otpVerifyButton = "Verificați",
    otpResend = "Retrimite codul",
    otpResendPrefix = "Nu ați primit codul?",
    otpWrongNumber = "Număr greșit?",
    otpModifyLink = "Modificați",
    forgotPasswordTitle = "Parolă uitată",
    forgotPasswordSubtitle = "Introduceți emailul pentru a primi un link de resetare",
    forgotPasswordButton = "Trimite link",
    forgotPasswordSuccess = "Verificați căsuța de email",
    resetPasswordTitle = "Parolă nouă",
    resetPasswordSubtitle = "Alegeți o parolă nouă pentru contul dvs.",
    resetPasswordNewLabel = "Parolă nouă",
    resetPasswordConfirmLabel = "Confirmați parola",
    resetPasswordButton = "Resetați parola",
    resetPasswordSuccess = "Parolă resetată. Acum vă puteți conecta.",
    errorPasswordTooShort = "Parola trebuie să aibă cel puțin 8 caractere",
    errorPasswordTooLong = "Parola nu poate depăși 128 de caractere",
    errorPasswordMismatch = "Parolele nu se potrivesc",
    errorTokenInvalid = "Acest link de resetare este invalid sau a expirat. Solicitați unul nou.",
    errorEmailInvalid = "Introduceti o adresa de email valida",
    errorPhoneRequired = "Introduceti un numar de telefon",
    errorInvalidCredentials = "Email sau parolă greșite. Folosiți 'Parolă uitată?' dacă este necesar.",
    errorInvalidOtp = "Cod greșit. Verificați SMS-ul sau solicitați unul nou.",
    errorExpiredOtp = "Cod expirat. Solicitați unul nou.",
    errorTooManyAttempts = "Prea multe încercări eșuate. Încercați din nou în câteva minute.",
    errorResendLimit = "Prea multe cereri de retrimitere. Încercați în câteva minute.",
    otpResendIn = "Retrimitere în %d s",
    otpAttemptsLeft = "Mai aveți %d încercări",
    loginGreeting = "Bun venit înapoi!",
    loginSubtitle = "Conectați-vă la contul Milta",
    loginSmsOption = "Primiți un cod SMS",
    noAccount = "Nu aveți încă un cont?",
    signUp = "Înregistrați-vă",
    organizationName = "Numele organizației",
    organizationNameRequired = "Vă rugăm să introduceți numele organizației",
    registerNextButton = "Următor",
    passwordConfirm = "Confirmați parola",
    passwordRuleUpper = "O literă majusculă",
    passwordRuleDigit = "O cifră",
    passwordRuleSpecial = "Un caracter special",
    alreadyHaveAccount = "Aveți deja un cont — Conectați-vă",
)
